import styles from './exportButton.module.css';
import Document from '../../../img/icons/document.svg';
export default function ExportButton ({ onClick }) {
  return (
    <button type='button' onClick={onClick} className={styles.button}>
      <span className={styles.iconAndTextWrapper}>
        <Document className={styles.icon} aria-hidden />
        <span className={styles.buttonText}>Export</span>
      </span>
    </button>
  );
}
